type Props = {
  className?: string;
};

// The resting Android edge handle, drawn like the native overlay, for the
// permission and done screens. The full flow is the recorded demo video.
const AndroidHandleDemo = ({ className = "" }: Props) => (
  <div
    aria-hidden
    data-testid="android-handle-demo"
    className={`relative h-[120px] w-full max-w-[300px] overflow-hidden rounded-[28px] bg-[var(--bg-secondary)] shadow-xl ring-1 ring-[var(--hairline)] ${className}`}
  >
    <div className="absolute right-1 top-[42%] -translate-y-1/2">
      <div className="desktop-lesson-bubble" data-mode="idle" />
    </div>
  </div>
);

export default AndroidHandleDemo;
